export default __webpack_public_path__ + "static/media/notification-nodata.68b01e52.svg";